import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionWhitelist } from './competition-whitelist'
import { CompetitionWhitelistSerializer } from './competition-whitelist.serializer'

@Injectable()
export class CompetitionWhitelistService extends ResourceService<CompetitionWhitelist> {
  constructor(
    private http: HttpClient,
    private competitionWhitelistSerializer: CompetitionWhitelistSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-white-list`,
      competitionWhitelistSerializer
    )
  }
}
